import React from 'react';
import { history } from 'umi';
import useGCPI18n from '@/hooks/useGCPI18n';
import successImg from '@/assets/images/memberShipCenter/myRewards/success.png';
import styles from './index.less';
import { Clickable } from '@/components';

const MemberSuccessPage = () => {
  const GCPI18n = useGCPI18n();
  const handleBack = () => {
    history.push('/memberShipCenterMyRewardsNew');
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.content}>
        <img className={styles.successImage} src={successImg} alt="" />
        <div className={styles.title}>{GCPI18n({ id: 'lb_membership_redemption_successful' })}</div>
        <div className={styles.subtitle}>{GCPI18n({ id: 'lb_membership_enjoy_your_reward' })}</div>
      </div>
      <div className={styles.bottomBar}>
        <Clickable className={styles.backBtn} onClick={handleBack}>
          {GCPI18n({ id: 'btn_membership_back_to_rewards' })}
        </Clickable>
      </div>
    </div>
  );
};

export default MemberSuccessPage;
